import { useTranslation } from 'react-i18next';
import RepairIconDuotone from '@/components/icons/RepairIconDuotone';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useMaintenanceApi } from '@/features/maintenance/hooks/useMaintenanceApi';
import { isHealthCheckOk } from '@/features/maintenance/healthCheckQuery';
import { useEffect } from 'react';
import { HEALTH_CHECK_INTERVAL_MS } from '@/features/maintenance/constants';
import {
    clearMaintenanceRedirectState,
    getMaintenanceReturnPath,
    isMaintenanceForced,
} from '@/features/maintenance/redirectState';

const MaintenancePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const maintenanceForced = isMaintenanceForced();

    const { healthCheckStatus } = useMaintenanceApi({
        refetchInterval: HEALTH_CHECK_INTERVAL_MS,
    });

    const isHealthy = isHealthCheckOk(healthCheckStatus);

    useEffect(() => {
        if (!isHealthy) {
            return;
        }

        const returnPath = getMaintenanceReturnPath();
        clearMaintenanceRedirectState();
        navigate(returnPath, { replace: true });
    }, [isHealthy, navigate]);

    const handleTryAgain = () => {
        const returnPath = getMaintenanceReturnPath();
        clearMaintenanceRedirectState();
        navigate(returnPath, { replace: true });
    };

    return (
        <div className="p-4 flex-1 flex flex-col items-center justify-center">
            <div className="max-w-md w-full flex flex-col items-center gap-4 text-center">
                <RepairIconDuotone className="size-8" />
                <div>
                    <h1 className="text-3xl font-medium mb-1">{t('main.maintenance.content-1')}</h1>
                    <p className="text-sm text-popover-600 leading-relaxed">
                        {t('main.maintenance.content-2')}
                    </p>
                    {maintenanceForced && (
                        <p className="mt-3 text-sm text-popover-600 leading-relaxed">
                            {t('main.maintenance.forcedDescription')}
                        </p>
                    )}
                </div>
                <div className="size-8 animate-spin rounded-full [background:conic-gradient(from_0deg,transparent_0%,#e5e7eb_45%,#9ca3af_75%,transparent_100%)] [mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)] [-webkit-mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)]" />
                <Button onClick={handleTryAgain} variant="outline">
                    {t('main.maintenance.tryAgain')}
                </Button>
            </div>
        </div>
    );
};

export default MaintenancePage;
